import { Injectable, inject } from '@angular/core'
import { Actions, createEffect } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { AsyncEffects } from '../../../shared/utils/redux/async.effects'
import { CompanyService } from '../../services/companyService'
import * as core from '../state'
import { CompaniesActions } from './companies.actions'
import { onStart } from '../../../shared/utils/redux/operators'
import { concatMap, switchMap, withLatestFrom } from 'rxjs/operators'
import { getCurrentCompany } from './companies.selectors'
import { SettingsActions } from '../../../jobsites-management/settings/store/settings.actions'

@Injectable()
export class CompaniesEffects {
  private actions$ = inject(Actions)
  private store = inject<Store<core.State>>(Store)
  private effectFactory = inject(AsyncEffects)
  private companiesService = inject(CompanyService)

  loadCompanies$ = createEffect(() =>
    this.effectFactory.asyncEffect(CompaniesActions.companies, () =>
      this.companiesService.getCompanies(),
    ),
  )

  updateCompanyTimezones$ = createEffect(() =>
    this.actions$.pipe(
      onStart(CompaniesActions.updateCompanyTimezones),
      withLatestFrom(this.store.select(getCurrentCompany)),
      switchMap(([action, company]) =>
        this.companiesService.updateCompanyAndRegionsTimezones(
          company.id,
          action.payload,
        ),
      ),
      concatMap(() => [
        CompaniesActions.companies.createStart(),
        SettingsActions.toggleDisplaySaveAlert.create(true),
      ]),
    ),
  )

  updateCompanyCsvPreferences$ = createEffect(() =>
    this.actions$.pipe(
      onStart(CompaniesActions.updateCompanyCsvPreferences),
      withLatestFrom(this.store.select(getCurrentCompany)),
      switchMap(([action, company]) =>
        this.companiesService.updateCompanyCsvPreferences(
          company.id,
          action.payload,
        ),
      ),
      concatMap(() => [
        CompaniesActions.companies.createStart(),
        SettingsActions.toggleDisplaySaveAlert.create(true),
      ]),
    ),
  )

  updateCompanyDefaultWorkingHours$ = createEffect(() =>
    this.actions$.pipe(
      onStart(CompaniesActions.updateCompanyDefaultWorkingHours),
      withLatestFrom(this.store.select(getCurrentCompany)),
      switchMap(([action, company]) =>
        this.companiesService.updateCompanyDefaultWorkingHours(
          company.id,
          action.payload,
        ),
      ),
      concatMap(() => [
        CompaniesActions.companies.createStart(),
        SettingsActions.toggleDisplaySaveAlert.create(true),
      ]),
    ),
  )

  updateCompanyDisabledTabs$ = createEffect(() =>
    this.actions$.pipe(
      onStart(CompaniesActions.updateCompanyDisabledTabs),
      withLatestFrom(this.store.select(getCurrentCompany)),
      switchMap(([action, company]) =>
        this.companiesService.updateCompanyDisabledTabs(
          company.id,
          action.payload,
        ),
      ),
      concatMap(() => [
        CompaniesActions.companies.createStart(),
        SettingsActions.toggleDisplaySaveAlert.create(true),
      ]),
    ),
  )
}
